import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManageUsersRoutingModule } from './manage-users-routing.module';
import { ManageUsersComponent } from './manage-users.component';
import { AllUsersComponent } from './all-users/all-users.component';
import { AddUserComponent } from './add-user/add-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { AgGridModule } from 'ag-grid-angular';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { EditUserSmartComponent } from './edit-user/edit-user-smart.component';


@NgModule({
  declarations: [ManageUsersComponent, AllUsersComponent, AddUserComponent, EditUserComponent, EditUserSmartComponent],
  imports: [
    FeaturesCommonModule,
    ManageUsersRoutingModule,
    AgGridModule.withComponents([]),
  ]
})
export class ManageUsersModule { }
